<template>
	<div class="container">
		<!--页面开始-->
		<div class="main_box">
			<div v-if="token" class="main_top">
				<div class="top_tit">
					亲爱的，{{ userPhone }}
				</div>
				<div class="top_tips">
					<van-popover
						v-model="showPopover"
						trigger="click"
						placement="bottom-end"
						:actions="popoverActions"
						@select="popoverSelect"
					>
						<template #reference>
							<van-icon name="setting-o" size="0.5rem" />
						</template>
					</van-popover>
				</div>
			</div>
			<div v-if="testData.two_status == null" class="banner_box">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/index_banner.png')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
			</div>
			<div v-if="testData.length != '' && testData.two_status != null"  class="result_box">
				<div class="img_box">
					<van-image
					  v-if="testData.two_status == 1"
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/icon_yinx.png')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
					<van-image
					  v-if="testData.two_status == 2"
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/icon_yangx.png')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
					<van-image
					  v-if="testData.two_status == 3"
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/icon_wux.png')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
				<div class="result_tit">
					<div class="result_tit_one">
						<template v-if="testData.two_status == 1" >您的抗原自检结果是&nbsp;&nbsp;<span style="color: #3AD80B;font-size: 0.45rem;font-weight: bold;">阴性</span></template>
						<template v-if="testData.two_status == 2">您的抗原自检结果是&nbsp;&nbsp;<span style="color: #ff0000;font-size: 0.45rem;font-weight: bold;">阳性</span></template>
						<template v-if="testData.two_status == 3">
							<!-- <div v-if="testData.remark !=''" style="padding-bottom: 0.1rem;">
								您的抗原自检结果无效，请重新检测
							</div> -->
							<div>
								您的抗原自检结果无效，请重新检测
								<van-icon name="question-o" size="0.4rem" color="#7494F6" @click="showWhy" />
							</div>
							<!-- <div v-if="testData.remark !=''" style="font-size: 0.35rem;color: #999999;" class="remark_box">
								无效原因：{{ testData.remark }}
							</div> -->
						</template>
					</div>
					<div class="result_tit_two">时间：{{ initTime(testData.create_time) }}</div>
				</div>
			</div>
			<div class="btn_box" v-if="testData != '' && testData.two_status == null">
				<img src="../../assets/img/index_icon_1.png" />
				<div class="btn_txt">
					<div class="txt_tit">您的抗原自检结果 <span style="font-size: 0.45rem;font-weight: bold;">审核中</span></div>
					<div class="txt_txt">检测时间：{{ initTime(testData.create_time) }}</div>
				</div>
			</div>
			<div class="btn_box_two">
				<div class="bnt_box_el" @click="goJc">
					<img src="../../assets/img/index_icon_01.png" />
					<div class="txt_box">
						立即检测
					</div>
				</div>
				<div class="bnt_box_el" @click="goPhoto">
					<img src="../../assets/img/index_icon_02.png" />
					<div class="txt_box">
						结果上传
					</div>
				</div>
			</div>
			<div class="btn_box" @click="goMsg">
				<img src="../../assets/img/index_icon_2.png" />
				<div class="txt_box">
					<div class="tit">信息管理</div>
					<div class="txt">身份信息实名认证</div>
				</div>
			</div>
			<div class="btn_box" @click="goJl">
				<img src="../../assets/img/index_icon_3.png" />
				<div class="txt_box">
					<div class="tit">检测记录</div>
					<div class="txt">历史检测结果查询</div>
				</div>
			</div>
			<div v-if="!token" class="login_box">
				<img class="img" src="../../assets/img/login_bg.png" />
				<div class="con_box">
					<div class="con_tit">
						赶快登录体验自检功能吧！
					</div>
					<div class="con_btn">
						<img src="../../assets/img/login_btn.png" @click="goLoginPage" />
					</div>
				</div>
			</div>
			<!--版权-->
			<div class="footer_box">
				<a href="https://beian.miit.gov.cn">冀ICP备2022012742号-1</a>
			</div>
			<!--版权-->
		</div>
		<!--页面开始-->
	    <!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
		<!--检测弹框-->
		<van-popup v-model="testBox" :close-on-click-overlay="false" style="width: 70%;">
			<div class="test_box">
				<div class="img_box">
					<img src="../../assets/img/icon_test.png" />
				</div>
				<div class="btn_box">
					<div class="btn_el" @click="userTest">
						本人检测
					</div>
					<div class="btn_el" @click="otherTest">
						帮他人测
					</div>
				</div>
				<div v-if="testBox" class="close_btn_box" @click="testBox = false">
					<van-icon name="cross" color="#ffffff" size="0.6rem" />
				</div>
			</div>
		</van-popup>
		<!--检测弹框-->
		<!--拍照弹框-->
		<van-popup v-model="photoBox" :close-on-click-overlay="false" style="width: 70%;">
			<div class="test_box">
				<div class="img_box">
					<img src="../../assets/img/icon_photo.png" />
				</div>
				<div class="btn_box">
					<div class="btn_el" @click="userPhoto">
						本人上传
					</div>
					<div class="btn_el" @click="otherPhoto">
						帮他人上传
					</div>
				</div>
				<div v-if="photoBox" class="close_btn_box" @click="photoBox = false">
					<van-icon name="cross" color="#ffffff" size="0.6rem" />
				</div>
			</div>
		</van-popup>
		<!--拍照弹框-->
		<!--引导-->
		<!--审核中-->
		<van-popup v-model="guideBox" style="width: 100%;background-color: transparent;border-radius: 0;">
			<div class="guide_box" :class="{'yx_box': yx_box, 'wjc_box': wjc_box, 'wx_box': wx_box}">
				<div v-show="guideStatus.status1" class="box_el one_box">
					<img src="../../assets/img/guide_1.png" />
					<div class="btn_box">
						<van-button plain type="default" size="small" @click="guideClick(1)">知道啦</van-button>
					</div>
				</div>
				<div v-show="guideStatus.status2" class="box_el two_box">
					<img src="../../assets/img/guide_2.png" />
					<div class="btn_box">
						<van-button plain type="default" size="small" @click="guideClick(2)">知道啦</van-button>
					</div>
				</div>
				<div v-show="guideStatus.status3" class="box_el three_box">
					<img src="../../assets/img/guide_3.png" />
					<div class="btn_box">
						<van-button plain type="default" size="small" @click="guideClick(3)">知道啦</van-button>
					</div>
				</div>
				<div v-show="guideStatus.status4" class="box_el four_box">
					<img src="../../assets/img/guide_4.png" />
					<div class="btn_box">
						<van-button plain type="default" size="small" @click="guideClick(4)">知道啦</van-button>
					</div>
				</div>
				<div v-show="guideStatus.status5" class="box_el five_box">
					<img src="../../assets/img/guide_5.png" />
					<div class="btn_box">
						<van-button plain type="default" size="small" @click="guideClick(5)">开始使用</van-button>
					</div>
				</div>
			</div>
		</van-popup>
		<!--引导-->
	</div>
</template>

<script>
import { getInfo, showInfo, msgBind } from "@/api/public";
import { indexList } from "@/api/record/index";
import { loginOut } from "@/api/login/index";
import { UPURL } from '@/utils/upload'
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,
			imgurl: '',
			testData: "",
			userPhone: '--',
			token: localStorage.getItem('token'),
			showPopover: false,
			popoverActions: [
				//{ text: '我的组织' },
				{ text: '' },
				{ text: '退出登录' },
			],
			testBox: false,  //检测弹框
			photoBox: false,  //拍照弹框
			guideBox: false,  //引导页
			guideStatus: {
				status1: false,
				status2: false,
				status3: false,
				status4: false,
				status5: false,
			},
			//引导页样式
			yx_box: false,
			wjc_box: false,
			wx_box: false,
			timeOver: null,  //定时器
		}
	},
	created(){
		let that = this;
		that.imgurl = UPURL;
		//60秒刷新检测接口
		that.timeOver = setInterval(() => {
			//审核中的检测结果刷新接口
			if(that.testData != '' && that.testData.two_status == null) {
				indexList({page: 1, page_size: 1}).then(res => {
					if(res.data.data.length > 0){
						that.testData = res.data.data[0];
					}
				});
			}
		}, 60000);
	},
	mounted() {
		//微信分享
		let that = this;
		if(that.token) {
			//请求检测列表
			indexList({page: 1, page_size: 1}).then(res => {
				if(res.data.data.length > 0) {
					//有检测记录
					that.testData = res.data.data[0];
					//判断结果状态测  设置引导页样式
					if(that.testData.two_status == null) {
						//审核中
						that.yx_box = false;
						that.wjc_box = false;
						that.wx_box = false;
					}else if(that.testData.two_status == 1 || that.testData.two_status == 2) {
						//阴/阳性
						that.wjc_box = false;
						that.wx_box = false;
						that.yx_box = true;
					}else if(that.testData.two_status == 3) {
						//无效
						that.wjc_box = false;
						that.yx_box = false;
						that.wx_box = true;
					}
				}else {
					//无检测记录  设置引导页样式
					that.yx_box = false;
					that.wx_box = false;
					that.wjc_box = true;
				}
				//请求个人信息
				getInfo().then(res1 => {
					if(res1.token.password != '') {
						that.popoverActions[0].text = '修改密码';
					}else {
						that.popoverActions[0].text = '设置密码';
					}
					if(res1.token.username != '' && res1.token.username != null) {
						that.userPhone = res1.token.username;
					}else {
						that.userPhone = res1.token.mobile;
					}
					// 查询主体
					// if(that.$route.query.type && that.$route.query.invite) {
					// 	showInfo({
					// 		type: that.$route.query.type,
					// 		invite_code: that.$route.query.invite,
					// 	}).then(res => {
					// 		//code: 2 无绑定信息
					// 		if(res.data.code == 2) {
					// 			that.$dialog.confirm({
					// 				title: '提示',
					// 				message: '您确定要绑定 ' + res.data.info.title + ' 的集体检测吗？',
					// 				confirmButtonText: '取消',
					// 				cancelButtonText: '确定',
					// 				confirmButtonColor: '#333333',
					// 			}).then(() => {
					// 				//点击关闭
					// 				that.$router.push({ query: {} });
					// 				that.$nextTick(() => {
					// 					//登录后显示引导页
					// 					if(res1.token.is_ones == 1) {
					// 						that.guideBox = true;
					// 						that.guideStatus.status1 = true;
					// 					}
					// 				}); 
					// 			}).catch(() => {
					// 				msgBind({
					// 					type: that.$route.query.type,
					// 					invite_code: that.$route.query.invite,
					// 				}).then(res => {
					// 					that.$router.push({ query: {} });
					// 					if(res.code == 1) {
					// 						that.$toast('绑定成功');
					// 						that.$nextTick(() => {
					// 							//登录后显示引导页
					// 							if(res1.token.is_ones == 1) {
					// 								that.guideBox = true;
					// 								that.guideStatus.status1 = true;
					// 							}
					// 						});
					// 					}else {
					// 						that.$toast('绑定失败');
					// 						setTimeout(() => {
					// 							that.$router.push({ query: {} });
					// 							that.$nextTick(() => {
					// 								//登录后显示引导页
					// 								if(res1.token.is_ones == 1) {
					// 									that.guideBox = true;
					// 									that.guideStatus.status1 = true;
					// 								}
					// 							}); 
					// 						}, 500);
					// 					}
					// 				});
					// 			});
					// 		}
					// 	});
					// }else {
					// 	that.$nextTick(() => {
					// 		//登录后显示引导页
					// 		if(res1.token.is_ones == 1) {
					// 			that.guideBox = true;
					// 			that.guideStatus.status1 = true;
					// 		}
					// 	}); 
					// }
					that.$nextTick(() => {
						that.isLoading = false;
						//登录后显示引导页
						if(res1.token.is_ones == 1) {
							that.guideBox = true;
							that.guideStatus.status1 = true;
						}
						//微信分享
						shareUrl(that);
					}); 
				});
			});
		}else {
			that.userPhone = localStorage.getItem('userPhone') || '--';
			that.isLoading = false;
		}
		sessionStorage.clear();
	},
	watch: {
		//
	},
	methods: {
		//引导页点击
		guideClick(value) {
			let that = this;
			switch(value) {
				case 1:
					that.guideStatus.status1 = false;
					that.guideStatus.status2 = true;
					break;
				case 2:
					that.guideStatus.status2 = false;
					that.guideStatus.status3 = true;
					break;
				case 3:
					that.guideStatus.status3 = false;
					that.guideStatus.status4 = true;
					break;
				case 4:
					that.guideStatus.status4 = false;
					that.guideStatus.status5 = true;
					break;
				case 5:
					that.guideStatus.status5 = false;
					that.guideBox = false;
					break;
			}
		},
		initTime(value) {
			if(value) {
				return moment(value * 1000).format("YYYY年MM月DD日 HH:mm:ss");
			}
		},
		//气泡弹出点击
		popoverSelect(action) {
			let that = this;
			switch(action.text) {
				case '修改密码':
					that.$router.push({path:'/forgetpwdtwo', query: {type: 2}});
					break;
				case '设置密码':
					that.$router.push({path:'/forgetpwdtwo', query: {type: 2}});
					break;
				case '我的组织':
					that.$router.push({path:'/organization'});
					break;
				case '退出登录':
					//退出登录
					loginOut().then(res => {
						sessionStorage.clear();
						localStorage.clear();
						that.$router.push({path:'/login'});
					});
					break;
			}
		},
		goLogin() {
			let that = this;
			if(that.$route.query.type && that.$route.query.invite) {
				that.$router.push({path:'/login', query: {type: that.$route.query.type, invite: that.$route.query.invite}});
			}else {
				that.$router.push({path:'/login'});
			}
		},
		//进入检测
		goJc() {
			let that = this;
			//校验是否登录
			if(that.token) {
				that.testBox = true;
			}else {
				that.goLogin();
			}
		},
		//本人检测
		userTest() {
			let that = this;
			that.$router.push({path:'/usermsg', query: {type: 1}});
		},
		//他人检测
		otherTest() {
			let that = this;
			that.$router.push({path:'/otherlist', query: {type: 1}});
		},
		//拍照上传
		goPhoto() {
			let that = this;
			//校验是否登录
			if(that.token) {
				that.photoBox = true;
			}else {
				that.goLogin();
			}
		},
		//本人拍照上传
		userPhoto() {
			let that = this;
			that.$router.push({path:'/usermsg', query: {type: 2}});
		},
		//他人拍照上传
		otherPhoto() {
			let that = this;
			that.$router.push({path:'/otherlist', query: {type: 2}});
		},
		//进入记录
		goJl() {
			let that = this;
			//校验是否登录
			if(that.token) {
				that.$router.push({path:'/recordindex'});
			}else {
				that.goLogin();
			}
		},
		//跳转登录
		goLoginPage() {
			this.goLogin();
		},
		//进入信息管理
		goMsg() {
			let that = this;
			//校验是否登录
			if(that.token) {
				that.$router.push({path:'/msgindex'});
			}else {
				that.goLogin();
			}
		},
		//无效原因
		showWhy(value) {
			let that = this;
			that.$toast('无效原因：' + that.testData.remark);
		},
	},
	beforeDestroy() {
		if(this.timeOver) {
			clearInterval(this.timeOver);
		}
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
/*loading*/
.loading{width:100%;height:100%;position:absolute;display:flex;justify-content:center;align-items:center;top:0;right:0;bottom:0;left:0;background:#ffffff;z-index:999;}
/*引导页 公共*/
.guide_box{
	width: 100%;
	height: 100vh;
}
.guide_box .box_el{
	width: 100%;
	height: 100%;
	padding: 0.5rem 0.6rem 0.6rem 0.6rem;
}
.guide_box .two_box{
	text-align: right;
}
.guide_box .five_box{
	text-align: right;
}
.guide_box .two_box img{
	width: 93%;
}
.guide_box .five_box img{
	width: 80%;
}
.guide_box img{
	width: 100%;
	height: auto;
	position: relative;
	top: 10rem;
}
.guide_box .three_box img{
	top: 8rem;
}
.guide_box .four_box img{
	top: 11.5rem;
}
.guide_box .five_box img{
	top: -0.2rem;
}
.guide_box .btn_box{
	position: relative;
	text-align: center;
	top: 10rem;
}
.guide_box .three_box .btn_box{
	top: -1rem;
}
.guide_box .four_box .btn_box{
	top: 2.5rem;
}
.guide_box .five_box .btn_box{
	top: 0.8rem;
}
/*阴性&阳性*/
.yx_box img{
	top: 8.7rem;
}
.yx_box .btn_box{
	top: 8.7rem;
}
.yx_box .three_box img{
	top: 6.8rem;
}
.yx_box .three_box .btn_box{
	top: -2.4rem;
}
.yx_box .four_box img{
	top: 10.2rem;
}
.yx_box .four_box .btn_box{
	top: 1.2rem;
}
/*无检测*/
.wjc_box img{
	top: 7rem;
}
.wjc_box .btn_box{
	top: 7rem;
}
.wjc_box .three_box img{
	top: 5rem;
}
.wjc_box .three_box .btn_box{
	top: -4rem;
}
.wjc_box .four_box img{
	top: 8.5rem;
}
.wjc_box .four_box .btn_box{
	top: 0rem;
}
/*无效*/
.wx_box img{
	top: 8.6rem;
}
.wx_box .btn_box{
	top: 8.6rem;
}
.wx_box .three_box img{
	top: 6.6rem;
}
.wx_box .three_box .btn_box{
	top: -2rem;
}
.wx_box .four_box img{
	top: 10.1rem;
}
.wx_box .four_box .btn_box{
	top: 1.6rem;
}

.guide_box .btn_box .van-button--plain{
	background-color: transparent;
	color: #ffffff;
}
.guide_box .btn_box .van-button--small{
	height: 32px !important;
	padding: 0 0.5rem;
}
.btn_box .van-button--small .van-button__text{
	font-size: 0.4rem !important;
}


.van-popup{
	border-radius: 0.15rem;
}
.close_btn_box{
	position: fixed;
	top: 0.2rem;
	right: 0.2rem;
}
.test_box .img_box img{
	width: 100%;
}
.test_box .btn_box{
	text-align: center;
}
.test_box .btn_el{
	padding: 0.43rem 0;
	font-size: 0.427rem;
	border-bottom: 1px solid #DCDCDC;
	color: #4A6EFF;
}

.top_tips{position: absolute;top: 0.05rem;right: 0.6rem;padding:0.5rem 0 0 0.45rem;color: #333333;display:inline-block;}
>>> .top_tips .van-button--small{
	height: 0.6rem;
	padding: 0 0.28rem;
	background-color: transparent;
}
>>> .top_tips .van-button__text{
	font-size: 0.32rem;
}

.main_box{
	width: 100%;
	height: 100vh;
	padding: 0.5rem 0.6rem 0.6rem 0.6rem;
}
.main_box .top_tit{
	width: 90%;
	font-size: 0.4rem;
	line-height: 1.5;
	white-space:nowrap; 
	overflow:hidden; 
	text-overflow:ellipsis;
}

.main_box .banner_box{
	margin-top: 0.4rem;
	margin-bottom: 0.3rem;
}
>>> .main_box .banner_box .van-image__img{
	width: 100%;
	border-radius: 0.32rem;
}

.main_box .result_box{
	margin-top: 0.4rem;
	margin-bottom: 0.4rem;
	text-align: center;
	background-color: #ffffff;
	color: #666666;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	overflow: hidden;
}
.result_tit_one{
	padding: 0.35rem 0 0 0.1rem;
	font-size: 0.38rem;
}
.result_tit_two{
	padding: 0.2rem 0 0.35rem 0;
	font-size: 0.38rem;
}
.result_box .img_box img{
	width: 100%;
}

.btn_box_two{
	position: relative;
	display: flex;
	padding-bottom: 0.4rem;
}
.btn_box_two .bnt_box_el{
	flex: 1;
	position: relative;
}
.btn_box_two .bnt_box_el:first-child{
	margin-right: 0.08rem;
}
.btn_box_two .bnt_box_el:last-child{
	margin-left: 0.08rem;
}
.btn_box_two .bnt_box_el img{
	width: 100%;
}
.btn_box_two .bnt_box_el .txt_box{
	position: absolute;
	top: 0.9rem;
	right: 0.5rem;
	color: #ffffff;
	font-size: 0.427rem;
}


.btn_box{
	width: 100%;
	position: relative;
}
.btn_box img{
	width: 100%;
	padding-bottom: 0.4rem;
}
.btn_box .txt_box{
	position: absolute;
	top: 0.7rem;
	right: 2rem;
	text-align: left;
	color: #ffffff;
}
.btn_box .txt_box .tit{
	padding-bottom: 0.1rem;
	font-size: 0.427rem;
}
.btn_box .txt_box .txt{
	padding-top: 0.1rem;
	font-size: 0.32rem;
}

.btn_txt{
	width: 100%;
	position: absolute;
	top: 0;
	color: #ffffff;
	text-align: center;
}
.btn_txt .txt_tit{
	padding-top: 0.5rem;
}
.btn_txt .txt_txt{
	padding-top: 0.3rem;
}

.login_box{
	width: 100%;
	height: 1.5rem;
	line-height: 1.5rem;
	position: fixed;
	bottom: 0;
	left: 0;
}
.login_box .img{
	width: 100%;
	height: 100%;
}
.login_box .con_box{
	width: 100%;
	position: absolute;
	top: 0;
	display: flex;
}
.con_box .con_tit{
	flex: 1;
	padding-left: 0.5rem;
	color: #ffffff;
}
.con_box .con_btn{
	width: 2.2rem;
	margin: 0.4rem 0.4rem 0 0;
}
.con_box .con_btn img{
	width: 100%;
}

.remark_box{
	padding: 0 0.2rem;
	white-space:nowrap;
	overflow:hidden; 
	text-overflow:ellipsis;
}
.footer_box{
	padding: 0.2rem 0;
	text-align: center;
}
.footer_box a{
	color: #666666;
}
</style>
